var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('Appbar',{on:{"search":_vm.getSearchedPosts,"toggleDrawer":_vm.toggleDrawer,"toggle-home":function($event){_vm.$router.push({ path: 'home' }).catch(error =>{return})}}}),_c('Drawer'),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }